import {
    Component,
    ChangeDetectionStrategy,
    Input,
    OnInit,
} from "@angular/core";
import { CartFragment } from "../../../common/generated-types";

@Component({
    selector: "vsf-cart-totals",
    templateUrl: "./cart-totals.component.html",
    styleUrls: ["./cart-totals.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartTotalsComponent {
    @Input() cart: CartFragment;
    @Input() stripeSurchargePercent: number = 0;
    @Input() isStripeSelected: boolean = false;

    getOriginalSubtotalWithTax(): number {
        if (!this.cart?.lines?.length) return 0;
        return this.cart.lines.reduce(
            (sum, line) => sum + line.unitPriceWithTax * line.quantity,
            0
        );
    }

    getTotalDiscountWithTax(): number {
        if (!this.cart?.discounts?.length) return 0;
        return this.cart.discounts.reduce(
            (sum, d) => sum + Number(d.amountWithTax),
            0
        );
    }

    getStripeSurchargeAmount(): number {
        if (this.stripeSurchargePercent > 0 && this.isStripeSelected) {
            return Math.round(
                this.cart.totalWithTax * (this.stripeSurchargePercent / 100)
            );
        }
        return 0;
    }

    getTotalWithStripeSurcharge(): number {
        return this.cart.totalWithTax + this.getStripeSurchargeAmount();
    }
}
